import { render, staticRenderFns } from "./AllProductsMenu.vue?vue&type=template&id=5b155688&scoped=true"
import script from "./AllProductsMenu.vue?vue&type=script&lang=js"
export * from "./AllProductsMenu.vue?vue&type=script&lang=js"
import style0 from "./AllProductsMenu.vue?vue&type=style&index=0&id=5b155688&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b155688",
  null
  
)

export default component.exports